function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "bg-curvy-desktop_svg__a",
  d: "M0 0h1454v449H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-14)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bg-curvy-desktop_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bg-curvy-desktop_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14 413.954c90.836-5.359 176.206-50.375 256.111-135.046C389.968 151.9 364.01 105.164 563.005 148.686 762 192.207 745.05 163.699 873 63.13c127.95-100.57 211-77.554 289 44.667 78 122.222 151 162.895 284 207.778 88.667 29.921 92.03 848.285 10.091 2455.09H14V413.956z",
  fill: "#181F2B",
  mask: "url(#bg-curvy-desktop_svg__b)"
}));

function SvgBgCurvyDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 449
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI0NDkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMCAwaDE0NTR2NDQ5SDB6Ii8+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNCkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTE0IDQxMy45NTRjOTAuODM2LTUuMzU5IDE3Ni4yMDYtNTAuMzc1IDI1Ni4xMTEtMTM1LjA0NkMzODkuOTY4IDE1MS45IDM2NC4wMSAxMDUuMTY0IDU2My4wMDUgMTQ4LjY4NiA3NjIgMTkyLjIwNyA3NDUuMDUgMTYzLjY5OSA4NzMgNjMuMTNjMTI3Ljk1LTEwMC41NyAyMTEtNzcuNTU0IDI4OSA0NC42NjcgNzggMTIyLjIyMiAxNTEgMTYyLjg5NSAyODQgMjA3Ljc3OCA4OC42NjcgMjkuOTIxIDkyLjAzIDg0OC4yODUgMTAuMDkxIDI0NTUuMDlIMTRWNDEzLjk1NnoiIGZpbGw9IiMxODFGMkIiIG1hc2s9InVybCgjYikiLz48L2c+PC9zdmc+";
export { SvgBgCurvyDesktop as ReactComponent };